import { useCrumbs } from "@/components/layout/CrumbsContext";
import { SolutionDetailView } from "@/components/plan-audit/SolutionDetailView";
import { useSolution } from "@/hooks/use-plan-audit";

export function SolutionPage({ slug }: { slug: string }) {
  const { data } = useSolution(slug);
  // Falls back to the slug until the name arrives, so the trail is never empty.
  useCrumbs([{ label: "Solutions", to: "/solutions" }, { label: data?.name ?? slug }]);
  return <SolutionDetailView slug={slug} />;
}
